import React, {useEffect, useState} from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine, ResponsiveContainer, Cell,
} from 'recharts';
import {numberFormatted} from "../utils/graph.util";

export default function PositiveNegativeBar(props) {
  const [data_key, setDataKey] = useState('');

  useEffect(() => {
    setDataKey(props.data_key);
  });

  return (
    <div className='shadow-lg p-1 p-4 bg-white dark:bg-gray-800'>
      <span className="text-gray-700 dark:text-gray-100 text-left font-bold my-4">{props.title}</span>
      <ResponsiveContainer width="100%"
                           height={300}>
        <BarChart
          width={550}
          height={300}
          data={props.entities}
          margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 0
          }}
        >
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey={props.group_by}/>
          <YAxis tickFormatter={numberFormatted()}/>
          {/*<Tooltip/>*/}
          <Tooltip contentStyle={{backgroundColor: "#8884d8", color: "#fff"}} itemStyle={{color: "#fff"}}
                   formatter={numberFormatted()}/>
          <ReferenceLine y={0} stroke="#000"/>
          <Bar dataKey={props.data_key} fill="#81b29a" /** label={{ position: 'top' }}**/ >
            {
              props.entities.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry[data_key] > 0 ? "#82ca9d":"#e63946"}/>
              ))
            }
          </Bar>
          {/*<Bar dataKey={props.data_key} fill="#8884d8"/>*/}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
